import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, Mail, ShieldAlert } from "lucide-react";

export function Farmacovigilanza() {
    return (
        <div className="container py-12 md:py-16">
            <Link to="/" className="inline-flex items-center text-text-body hover:text-brand-primary mb-8 transition-colors">
                <ArrowLeft className="h-4 w-4 mr-2" /> Torna alla Home
            </Link>
            
            <div className="max-w-4xl mx-auto">
                <div className="flex items-center gap-3 mb-6">
                    <ShieldAlert className="h-8 w-8 text-brand-primary" />
                    <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-title">Farmacovigilanza</h1>
                </div>
                
                <div className="prose prose-lg text-text-body max-w-none mb-10">
                    <h2 className="text-2xl font-bold text-text-title mb-4">Che cos'è e a che cosa serve?</h2>
                    
                    <h3 className="text-xl font-bold text-brand-primary mb-2">Cos’è la farmacovigilanza</h3>
                    <p className="mb-6">
                        È il complesso di attività finalizzate a valutare in maniera continuativa tutte le informazioni relative alla sicurezza dei farmaci e ad assicurare, per tutti i medicinali in commercio, un rapporto beneficio/rischio favorevole per la popolazione.
                    </p>

                    <h3 className="text-xl font-bold text-brand-primary mb-2">Cos’è una reazione avversa a un medicinale</h3>
                    <p className="mb-4">
                        È un effetto nocivo, non voluto conseguente all’utilizzo di un medicinale.
                    </p>
                    <p className="mb-6">
                        Le reazioni avverse possono derivare sia da un uso autorizzato che da un uso non autorizzato del medicinale (sovradosaggio, uso improprio, abuso, errori terapeutici).
                    </p>

                    <h3 className="text-xl font-bold text-brand-primary mb-2">Come e a chi segnalare una sospetta reazione avversa</h3>
                    <p className="mb-4">
                        Le attività di farmacovigilanza coinvolgono, a diversi livelli, tutta la comunità: pazienti, medici, operatori sanitari, aziende farmaceutiche (titolari AIC).
                    </p>
                    <p className="mb-6">
                        Qualsiasi sospetta reazione avversa che si manifesti durante l’uso di un medicinale deve essere segnalata tempestivamente al proprio medico o al farmacista, oppure alla struttura sanitaria di riferimento.
                    </p>

                    <h3 className="text-xl font-bold text-brand-primary mb-2">Segnalazioni online</h3>
                    <p className="mb-4">
                        Le segnalazioni possono essere fatte sia dagli operatori sanitari che dai cittadini, tramite gli appositi moduli ed i canali definiti dall’autorità regolatoria nazionale (AIFA – Agenzia Italiana del Farmaco).
                    </p>
                    <p className="mb-6">
                        Le segnalazioni devono essere trasmesse ai Responsabili di Farmacovigilanza della struttura sanitaria di appartenenza (aziende sanitarie locali, ospedali, ecc.).
                    </p>

                    <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-8">
                        <h4 className="text-lg font-bold text-text-title mb-4">Link Utili per le Segnalazioni</h4>
                        <ul className="space-y-4">
                            <li>
                                <span className="block mb-1">AIFA mette a disposizione i moduli da utilizzare per le segnalazioni al seguente link:</span>
                                <a 
                                    href="http://www.aifa.gov.it/content/come-segnalare-una-sospetta-reazione-avversa" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center text-brand-primary hover:underline font-medium"
                                >
                                    Moduli segnalazione AIFA <ExternalLink className="h-4 w-4 ml-1" />
                                </a>
                            </li>
                            <li>
                                <span className="block mb-1">Vi è anche la possibilità di comunicare una sospetta reazione avversa direttamente on-line sul sito di VIGIFARMACO - AIFA al seguente link:</span>
                                <a 
                                    href="https://www.vigifarmaco.it/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center text-brand-primary hover:underline font-medium"
                                >
                                    www.vigifarmaco.it <ExternalLink className="h-4 w-4 ml-1" />
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-blue-50 p-6 rounded-xl border border-blue-100 mb-8">
                        <h3 className="text-xl font-bold text-brand-primary mb-4 flex items-center">
                            <Mail className="h-5 w-5 mr-2" />
                            Contatto Diretto
                        </h3>
                        <p className="mb-4">
                            Nel caso in cui il segnalatore volesse contattare direttamente il titolare AIC Sapio Produzione Idrogeno Ossigeno, per segnalare una sospetta reazione avversa:
                        </p>
                        <a 
                            href="mailto:farmacovigilanza@sapio.it" 
                            className="inline-block bg-white text-brand-primary px-4 py-2 rounded-lg border border-blue-200 font-bold hover:bg-blue-50 transition-colors mb-4"
                        >
                            farmacovigilanza@sapio.it
                        </a>
                        <p className="text-sm text-gray-600 mt-2">
                            Si prega di inviare la segnalazione non prima di aver letto il testo integrale dell’informativa sul trattamento dei dati personali.
                        </p>
                        <div className="mt-4">
                            <Link to="/privacy" className="text-brand-primary font-bold hover:underline">
                                Leggi l’Informativa Privacy
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
